/*
*  AGP events
*  Fichier de gestion spécifique editions
*/

import $ from "jquery";
import 'jquery-ui';
import Common from "./agp_common";


let edition = {};

export default class Editions {

    constructor(el) {
        this.DOM = {el: el};
    }

    init() {
        let _this = this;


        //////////////////////////////////////////
        // UPDATE CONTROLE
        $('#edition_date_deb, #edition_date_end').on('input', function () {
            $('#edition_date_end').removeClass("_field_error");
            var startDate = $('#edition_date_deb').val();
            var endDate = $('#edition_date_end').val();

            if (startDate && endDate) {
                if (startDate > endDate) {
                    alert('La date de fin doit être supérieure à la date de début');
                    $('#edition_date_end').addClass("_field_error");
                }
            }
        });

        ///////////////////////////////////////////////
        // SELECT EVENT / CREATION EDITION
        $("#edition_event").on("change", function () {

            var _event = $(this).val();
            if (_event != "") {
                _this.getEditions(_event);
            }else{
                let selectElement = $("select[name=edition_duplicate]");
                selectElement.empty();
                var newOption = jQuery('<option>', {
                    value: "",
                    text: "Sélectionnez un événement"
                });
                selectElement.append(newOption);
            }

        });

        // Si un événement est pré-sélectionné (ex: un seul choix),
        // charger automatiquement la liste des éditions à dupliquer.
        if ($("#edition_event").length > 0) {
            var _event_init = $("#edition_event").val();
            if (_event_init !== "") {
                _this.getEditions(_event_init);
            }
        }

        //////////////////////////////////////////
        // UPDATE CONTROLE MONTAGE
        //alert($('#montage_date_deb').length);
        // $('#montage_date_deb').on('input', function () {
        //     //alert("->");
        //     // $('#montage_date_end').removeClass("_field_error");
        //     // var startDate = $('#montage_date_deb').val();
        //     // var endDate = $('#montage_date_end').val();
        //     //
        //     // if (startDate && endDate) {
        //     //     if (startDate > endDate) {
        //     //         alert('La date de fin doit être supérieure à la date de début');
        //     //         $('#montage_date_end').addClass("_field_error");
        //     //         // You can perform additional actions or validations here
        //     //     }
        //     // }
        // });


        //////////////////////////////////////////
        // GENERIQUE MODALS
        $(document).on("click", ".close_modal", function () {
            $(".__modal").removeClass("_show");
        });

        $(document).on("click", ".__open_modal", function () {
            $(".__modal").addClass("_show");
        });

        ////////////////////////////////////
        // GESTION NB PASSAGES SOUS-CATEGORIES
        if ($("input[name=_edition_categories]").length > 0) {

            // MODIFICATION PAR ZONE
            $(document).on("change", "select[name='zones[]']", function () {
                _this.addPassages("zone");
            });

            // MODIFICATION PAR JOUR
            $(document).on("change", "select[name='jours[]']", function () {
                _this.addPassages("jour");
            });

        }

        $(document).on("input", "input[name=all_passages]", function () {
            var _val = $(this).val();
            if (!isNaN(_val)) {
                if ($('input[name^="access_passage["][name$="]"]').length > 0) {
                    $('input[name^="access_passage["][name$="]"]').each(function () {
                        // Set the value of the input element to the source value
                        $(this).val(_val);
                    });
                } else {
                    $('input[name^="passages["][name$="]"]').each(function () {
                        // Set the value of the input element to the source value
                        $(this).val(_val);
                    });
                }
            }
        });

        //alert($('input[name^="access_passage["][name$="]"]').length);

        //access_passage
        $('input[name^="passages["][name$="]"], input[name^="access_passage["][name$="]"]').on('input', function () {
            // Get the value of the input element
            var inputValue = $(this).val();

            // Check if the input value is numeric
            if (isNaN(inputValue)) {
                // Do something with the numeric value
                alert("la valeur n'est pas numérique");
                $(this).val("0");
            }
        });

    }

    // recupere editions event
    getEditions(event) {
        let _this = this;

        $.ajax({
            url: _URL + "/editions/get-event-editions",
            data: {
                event_id: event
            },
            type: "POST",
            context: document.body
        }).done(function (response) {

            if (response === "empty") {
                $(".edition_duplication").css("visibility", "hidden");
            } else {
                $(".edition_duplication").css("visibility", "visible");
                let selectElement = $("select[name=edition_duplicate]");
                let obj = JSON.parse(response);
                selectElement.empty();
                var newOption = jQuery('<option>', {
                    value: "",
                    text: "Sélectionnez une édition à dupliquer"
                });
                var separatorOption = jQuery('<option>', {
                    disabled: true,
                    text: '-----------------'
                });
                selectElement.append(newOption);
                selectElement.append(separatorOption);

                jQuery.each(obj, function (key, item) {
                    var newOption = jQuery('<option>', {
                        value: item.id,
                        text: item.name
                    });
                    selectElement.append(newOption);
                });

            }

        });
    }

    addPassages(type) {

        let _this = this;

        let tab_dates = JSON.parse($("input[name=_tab_dates]").val());
        let tab_zones = JSON.parse($("input[name=_tab_zones]").val());


        let _zones = $("select[name='zones[]']").multipleSelect("getSelects").map(Number);
        let _jours = $("select[name='jours[]']").multipleSelect("getSelects").map(Number);

        let _array_type_table = [];
        let _tab_type = _jours;
        let _tab_other = _zones;
        if (type === "zone") {
            _tab_type = _zones;
            _tab_other = _jours;
        }

        $(".table_passages > tr").each(function (id, item) {
            if ($(this).data("all") === undefined) {
                let __get_type = $(item).data(type);
                if (_tab_type.indexOf(__get_type) === -1) {
                    $(item).remove();
                } else {
                    if (_array_type_table.indexOf(__get_type) === -1) {
                        _array_type_table.push(__get_type);
                    }
                }
            }
        });

        if (_zones.length > 0 && _jours.length > 0) {

            _tab_type.forEach(function (i) {

                if (_array_type_table.indexOf(i) === -1) {

                    if (type === "zone") {
                        let get_zone = tab_zones.find(get_zone => parseInt(get_zone.id) === i);
                        _jours.forEach(function (jour_id) {
                            let get_date = tab_dates.find(get_date => parseInt(get_date.id) === jour_id);
                            var $add = '<tr data-zone="' + i + '" data-jour="' + jour_id + '"><td>' + get_date.date + '</td><td>' + get_zone.label + '</td><td>' +
                                '<input type="text" class="text-center" name="passages[' + jour_id + '][' + i + ']" value="1">' +
                                '</td></tr>';
                            $(".table_passages").append($add);
                        });
                    } else {
                        let get_date = tab_dates.find(get_date => parseInt(get_date.id) === i);
                        _zones.forEach(function (zone_id) {
                            let get_zone = tab_zones.find(get_zone => parseInt(get_zone.id) === zone_id);
                            var $add = '<tr data-zone="' + zone_id + '" data-jour="' + i + '"><td>' + get_date.date + '</td><td>' + get_zone.label + '</td><td>' +
                                '<input type="text" class="text-center" name="passages[' + i + '][' + zone_id + ']" value="1">' +
                                '</td></tr>';
                            $(".table_passages").append($add);
                        });

                    }

                }
            });
        }

        _this.orderTable();

    }

    orderTable() {
        var rows = $(".table_passages > tr");
        $("._nb_passages").html('(' + rows.length + ')');
        rows.sort(function (a, b) {
            var valueA = parseInt($(a).data('jour'));
            var valueB = parseInt($(b).data('jour'));
            return valueA - valueB;
        }).appendTo('.table_passages');
    }

}